module.exports = __webpack_public_path__ + "img/photo-icon.84b307e9.svg";